import React from 'react';
import { Container } from '@mui/material';
import { useParams } from 'react-router';
import { CurrentCollectionProvider, DetailOrderHeader } from '@europrocurement/l2d-modules';
import { OrderBody } from '../../components';

const OrderDetail: React.FunctionComponent = function () {
    const { idOrder } = useParams();
    if (!idOrder) {
        console.warn(`Commande non trouvée paramètres url:  ${idOrder}`);
        throw new Error(`Commande non trouvée paramètres url:  ${idOrder}`);
    }
    return (
        <CurrentCollectionProvider
            autoload
            idCollection={idOrder}
        >
            <Container maxWidth="lg">
                <DetailOrderHeader />
                <OrderBody />
            </Container>
        </CurrentCollectionProvider>
    );
};

export default OrderDetail;
